export enum PAYMENT_STATUS {
  INITIATED = "INITIATED",
  PENDING = "PENDING",
  CANCELED = "CANCELLED",
  SUCCESS = "SUCCESS",
  DECLINED = "DECLINED",
  EXPIRED = "EXPIRED",
  ERROR = "ERROR",
}
